var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPovPanoramaMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "br9wjh9tfa",
    width: "233.3%",
    height: "176.2%",
    x: "-66.7%",
    y: "-38.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.17254902 0 0 0 0 0.17254902 0 0 0 0 0.17254902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0056FF"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#br9wjh9tfa)",
    transform: "translate(-95.000000, -592.000000) translate(101.000000, 598.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 15,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0L9 6 3 6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPovPanoramaMarker);
export default __webpack_public_path__ + "static/media/pov-panorama-marker.005390fe1e25bf664dc3a9cb6aa816a2.svg";
export { ForwardRef as ReactComponent };